import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const META_DESCRIPTIONS = {
  '/': 'Gamified performance tracking platform with virtual pets, achievements, and team challenges. Boost productivity and engagement with our comprehensive activity management system.',
  '/auth': 'Sign in to ActivityTracker - Access your personalized dashboard, track your progress, and manage your virtual pet companion.',
  '/login': 'Sign in to ActivityTracker - Access your personalized dashboard, track your progress, and manage your virtual pet companion.',
  '/reset-password': 'Reset your ActivityTracker password - Regain access to your account and continue your productivity journey.',
  '/dashboard': 'Your ActivityTracker Dashboard - Monitor your progress, care for your virtual pet, complete challenges, and achieve your goals.',
  
  '/activity': 'Activity Details - View detailed information about your logged activities, progress, and achievements.',
  '/404': 'Page Not Found - The page you\'re looking for doesn\'t exist. Return to ActivityTracker to continue your productivity journey.'
};

const META_TITLES = {
  '/': 'ActivityTracker - Performance Management Platform',
  '/auth': 'Sign In - ActivityTracker',
  '/login': 'Sign In - ActivityTracker',
  '/reset-password': 'Reset Password - ActivityTracker',
  '/dashboard': 'Dashboard - ActivityTracker',
  
  '/activity': 'Activity Details - ActivityTracker',
  '/404': 'Page Not Found - ActivityTracker'
};

export const useMetaDescription = () => {
  const location = useLocation();

  useEffect(() => {
    // Use timeout to let page-specific SEO (usePageSEO) run first
    const timeoutId = setTimeout(() => {
      const path = location.pathname;
      const pathLower = path.toLowerCase();

      // These routes manage their own SEO via usePageSEO
      if (pathLower.includes('/attendance') || 
          pathLower.includes('/tracker') ||
          pathLower.startsWith('/events')) {
        return;
      }
      
      // Get exact match first
      let description = META_DESCRIPTIONS[path as keyof typeof META_DESCRIPTIONS];
      let title = META_TITLES[path as keyof typeof META_TITLES];
      
      // Handle dynamic routes
      if (!description) {
        if (path.startsWith('/activity/')) {
          description = META_DESCRIPTIONS['/activity'];
          title = META_TITLES['/activity'];
        } else {
          description = META_DESCRIPTIONS['/404'];
          title = META_TITLES['/404'];
        }
      }

      // Update meta description
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }

      // Update Open Graph description
      const ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.setAttribute('content', description);
      }

      // Update Twitter description
      const twitterDescription = document.querySelector('meta[name="twitter:description"]');
      if (twitterDescription) {
        twitterDescription.setAttribute('content', description);
      }

      // Update page title
      document.title = title;

      // Update Open Graph title
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.setAttribute('content', title);
      }

      // Update Twitter title
      const twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (twitterTitle) {
        twitterTitle.setAttribute('content', title);
      }
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [location.pathname]);
};